import { PapybaseConfig } from '@luxtag/papybase';

const papybaseConfig: PapybaseConfig = {
    baseURL: 'https://x2.event.luxtag.io',
    // baseURL: 'http://localhost:8000',
    timeout: 8000,
};

export default papybaseConfig;
